<template>
  <div class="cancelReason">
    <Nav :title="title" :back="back"></Nav>
    <div class="content" :class="{ isIosx: isiOSX }">
      <!-- <div class="contentTop">
        <img src="./../../assets/takingCar/succeed.png" alt="" />
        <h2>订单取消成功</h2>
        <p>请填写取消原因，我们会为您提供更好的服务</p>
      </div> -->
      <div class="reason passenger">
        <van-collapse :border="false" v-model="activeNames" accordion>
          <van-collapse-item title="乘客原因" name="1">
            <van-radio-group v-model="radio">
              <van-cell-group>
                <van-cell
                  :title="item.cancel_reason"
                  clickable
                  v-for="(item, index) in member"
                  :key="index"
                  @click="passengerChange(item)"
                >
                  <template #right-icon>
                    <van-radio :name="item.cancel_code" shape="square" />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
          </van-collapse-item>
          <van-collapse-item title="司机原因" name="2">
            <van-radio-group v-model="motormanRadio">
              <van-cell-group>
                <van-cell
                  :title="item.cancel_reason"
                  clickable
                  @click="motormanChange(item)"
                  v-for="(item, index) in driver"
                  :key="index"
                >
                  <template #right-icon>
                    <van-radio :name="item.cancel_code" shape="square" />
                  </template>
                </van-cell>
              </van-cell-group>
            </van-radio-group>
          </van-collapse-item>
        </van-collapse>
      </div>
      <!-- <div class="reason motorman">
        <van-collapse :border="false" v-model="activemotorman">
         
        </van-collapse>
      </div> -->
    </div>
    <div class="btn">
      <div @click="taxiToCanelOrder" class="outbtndiv">
        <van-button
          size="large"
          color="#E0E0E0"
          :class="btnshow ? 'showbtn' : ''"
          v-if="isTrue"
          >提交原因</van-button
        >
        <van-button
          loading
          v-else
          loading-text="提交中..."
          size="large"
          color="#E0E0E0"
        />
      </div>
    </div>
  </div>
</template>

<script>
import Nav from "./nav";
export default {
  data() {
    return {
      title: "选择取消原因",
      activeNames: "1",
      radio: "0",
      motormanRadio: "0",
      driver: [],
      member: [],
      btnshow: false,
      cancel_code: "0",
      cancel_reason: "",
      taxis_order_sn: "",
      isTrue: true,
      back: 1,
      is_need_cancel_fee: 0,
      type: -1,
    };
  },
  components: { Nav },
  created() {
    this.$api.setToken(this.$route.query.token);

    this.isiOSX = this.isIphoneX();
    this.getCancelReason();
    if (this.$route.query.taxis_order_sn) {
      this.taxis_order_sn = this.$route.query.taxis_order_sn;
    }
    if (this.$route.query.is_need_cancel_fee) {
      this.is_need_cancel_fee = this.$route.query.is_need_cancel_fee;
      this.back = 0;
      this.type = 1;
    }
    // console.log(this.taxis_order_sn);
  },
  methods: {
    //   乘客原因选择
    passengerChange(item) {
      this.motormanRadio = "0";
      this.btnshow = true;
      this.radio = item.cancel_code;
      this.cancel_code = item.cancel_code;
      this.cancel_reason = item.cancel_reason;
    },
    //   司机原因选择
    motormanChange(item) {
      this.radio = "0";
      this.btnshow = true;
      this.motormanRadio = item.cancel_code;
      this.cancel_code = item.cancel_code;
      this.cancel_reason = item.cancel_reason;
    },
    beforeClose(action, done) {
      if (action === "confirm") {
        this.$api
          .post("/taxis/member/order/cancel", {
            taxis_order_sn: this.taxis_order_sn,
            cancel_code: this.cancel_code,
            cancel_reason: this.cancel_reason,
            type: 1,
          })
          .then((req) => {
            done();
            this.isTrue = true;
            let param = {
              taxis_order_sn: req.taxis_order_sn,
              cancel_status: req.cancel_status,
            };
            this.params(
              JSON.stringify(param),
              JSON.stringify(param),
              "cancelSuccess"
            );
          })
          .catch((req) => {
            done();
            this.btnshow = true;
            this.isTrue = true;
            this.$toast(req.message);
          });
      } else {
        // console.log("quxiao");
        done();
      }
    },
    // 跳转到取消成功页面
    taxiToCanelOrder() {
      if (this.btnshow) {
        this.btnshow = false;
        this.isTrue = false;
        // setTimeout(() => {
        //   this.btnshow = true;
        // }, 3000);
        if (this.cancel_code != 0) {
          let param = {
            taxis_order_sn: this.taxis_order_sn,
            cancel_code: this.cancel_code,
            cancel_reason: this.cancel_reason,
          };
          this.$api
            .post("/taxis/member/order/cancel", {
              taxis_order_sn: this.taxis_order_sn,
              cancel_code: this.cancel_code,
              cancel_reason: this.cancel_reason,
              type: this.type,
            })
            .then((res) => {
              this.btnshow = true;
              console.log(res);
              if (res.cancel_status == -1) {
                this.isTrue = true;
                this.$dialog
                  .confirm({
                    message:
                      "您的订单已经被接单啦～现在取消的话，可能要支付给司机 <span>3-5元</span>  的补偿费噢～您确定还要取消吗？",
                    confirmButtonText: "仍要取消",
                    confirmButtonColor: "#F9591B",
                    cancelButtonText: "去查看",
                    cancelButtonColor: "#999999",
                    messageAlign: "left",
                    className: "dialog",
                    allowHtml: true,
                    beforeClose: this.beforeClose,
                  })
                  .then(() => {
                    // 重新调用取消
                    // on confirm
                    console.log("1");
                    // this.$api
                    //   .post("/taxis/member/order/cancel", {
                    //     taxis_order_sn: this.taxis_order_sn,
                    //     cancel_code: this.cancel_code,
                    //     cancel_reason: this.cancel_reason,
                    //     type: 1,
                    //   })
                    //   .then((req) => {
                    //     this.isTrue = true;
                    //     let param = {
                    //       taxis_order_sn: req.taxis_order_sn,
                    //       cancel_status: req.cancel_status,
                    //     };
                    //     this.params(
                    //       JSON.stringify(param),
                    //       JSON.stringify(param),
                    //       "cancelSuccess"
                    //     );
                    //   })
                    //   .catch((req) => {
                    //     this.btnshow = true;
                    //     this.isTrue = true;
                    //     this.$toast(req.message);
                    //   });
                  })
                  .catch(() => {
                    console.log("2");
                    let param = {
                      taxis_order_sn: res.taxis_order_sn,
                      status: res.status,
                    };
                    this.params(
                      JSON.stringify(param),
                      JSON.stringify(param),
                      "goToLookDetail"
                    );
                    // on cancel
                  });
              } else {
                let param = {
                  taxis_order_sn: res.taxis_order_sn,
                  cancel_status: res.cancel_status,
                };
                this.params(
                  JSON.stringify(param),
                  JSON.stringify(param),
                  "cancelSuccess"
                );
              }
            })
            .catch((res) => {
              this.btnshow = true;
              this.isTrue = true;
              console.log(res);
              this.$toast(res.message);
            });
          // console.log(param);
          // this.params(
          //   JSON.stringify(param),
          //   JSON.stringify(param),
          //   "taxiToCanelOrder"
          // );
        }
      }
    },
    // 获取取消原因
    getCancelReason() {
      this.$api
        .post("/taxis/member/order/cancel/reason", { short_name: "CaoCao" })
        .then((res) => {
          console.log(res);
          this.driver = res.driver;
          this.member = res.member;
        });
    },
  },
  mounted() {},
};
</script>

<style lang="less">
.dialog {
  .van-dialog__message {
    font-size: 15px;
    line-height: 23px;
    color: #333333;
    span {
      color: #f9591b;
    }
  }
}
.cancelReason {
  background: #f5f6f7;
  min-height: 100%;
  .content {
    padding-top: 70px;
    margin: 0px 15px 0;
    padding-bottom: 110px;
    .contentTop {
      margin-top: 15px;
      padding-bottom: 30px;
      img {
        width: 64px;
        height: 64px;
        display: block;
        margin: 15px auto 20px;
      }
      h2 {
        color: #333333;
        font-size: 20px;
        line-height: 28px;
        text-align: center;
      }
      p {
        color: #999999;
        font-size: 14px;
        line-height: 20px;
        text-align: center;
        margin-top: 10px;
      }
    }
    .passenger {
      margin-top: 30px;
    }
    .reason {
      // background-color: #ffffff;
      border-radius: 5px;
      // padding: 12px;
      // border: 1px solid red;
      .van-collapse-item--border::after {
        border-bottom: none;
      }
      .van-collapse-item {
        margin-bottom: 15px;
        border-radius: 5px;
        overflow: hidden;

        .van-cell {
          border-radius: 5px;
        }
        .van-icon {
          border-radius: 2px;
        }
      }
      .van-cell__title {
        color: #333333;
        font-size: 16px;
        font-weight: bolder;
      }
      .van-collapse-item__content {
        padding: 0;
        // border: 1px solid blue;
        .van-cell__title {
          font-size: 14px;
          font-weight: normal;
        }
      }
      .van-radio__icon--checked .van-icon {
        color: #181818;
        background-color: #ffb600;
        border-color: #ffb600;
      }
      .van-cell::after,
      .van-collapse-item__title::after {
        border-bottom: none;
      }
    }

    .motorman {
      margin-top: 15px;
    }
  }
  .btn {
    width: 100%;
    height: 104px;
    background-color: #ffffff;
    position: fixed;
    bottom: 0;
    left: 0;
    .outbtndiv {
      width: 90%;
      margin: 0px auto;
    }
    button {
      margin-top: 10px;
      border-radius: 5px;
    }
    .showbtn {
      background-color: #181818 !important;
    }
  }

  .isIosx {
    padding-top: 90px;
  }
}
</style>
